(function () {
    'use strict';

    angular.module('iMatApp')
        .controller('MultipleFileUploadController', MultipleFileUploadController);

    MultipleFileUploadController.$inject = ['$scope', '$uibModal', 'workspace', 'workflow', 'eventService', 'multipleUploadTrackEventsService', 'userSettingsService'];

    function MultipleFileUploadController($scope, $uibModal, workspace, workflow, eventService, trackEventsService, userSettingsService) {
        var vm = this;

        vm.units = workspace.settings.units || 0;
        vm.files = null;

        vm.uploadFiles = uploadFiles;
        vm.addFromUploadedModels = addFromUploadedModels;
        vm.setUnits = setUnits;

        eventService.subscribe($scope, 'filesDropped', filesDropped);

        // -----------------------------------------------------------------------------------
        function filesDropped(files) {
            if (!files || files.length === 0) {
                return;
            }

            workflow.selectFiles(files, vm.units);
            trackEventsService.trackFilesDropped(files);
        }

        function uploadFiles(files) {
            if (!files || files.length === 0) {
                return;
            }

            workflow.selectFiles(files, vm.units);
            trackEventsService.trackBrowseFiles(files);
        }

        function addFromUploadedModels() {
            showUploadedModelsWindow()
                .then(function (modelIds) {
                    if (modelIds && modelIds.length > 0) {
                        workflow.selectModels(modelIds);
                        trackEventsService.trackAddPreviouslyUploadedModels(modelIds);
                    }
                });
        }

        function setUnits(value) {
            if (angular.isUndefined(value)) {
                vm.units = workspace.settings.units;
            }

            vm.units = parseInt(value, 10);
            userSettingsService.setUnits(vm.units);
        }

        // ----------------------------------- Private functions -----------------------------

        function showUploadedModelsWindow() {
            var modalWindow = $uibModal.open({
                templateUrl: '/Scripts/iMatApp/model/views/previouslyUploadedModelsWindowView.html',
                controller: 'PreviouslyUploadedModelsWindowController',
                controllerAs: 'windowViewModel',
                resolve: {
                    multiselect: true
                }
            });

            return modalWindow.result;
        }
    }
})();